<template>
  <a-card v-if="pageLoading">
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="pageLoading"
    />
  </a-card>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'" v-else>
    <a-row :gutter="8">
      <a-col :xs="{ span: 24 }">
        <a-card :loading="pageLoading" class="margin-bottom">
          <div slot="title">Evaluation Supplier Manifest
            <small class="m-display-block m-text-small">{{
              data.header.no_trans
            }}</small>
          </div>

          <div class="m-card-body">
            <ul class="m-list-wrapper bordered">
              <li>
                <span class="m-list-title" for>Supplier Name</span>
                <span class="m-list-desc">{{ data.header.supplier_name }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Address</span>
                <span class="m-list-desc">{{ data.header.addres }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Bank Account Number</span>
                <span class="m-list-desc">{{ data.header.no_account_bank }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Bank Name</span>
                <span class="m-list-desc">{{ data.header.bank }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Contact Person</span>
                <span class="m-list-desc">{{ data.header.contact_person }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Type of Product</span>
                <span class="m-list-desc">{{ data.header.type_of_product }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Category</span>
                <span class="m-list-desc">{{ data.header.category }}</span>
              </li>
            </ul>
          </div>
        </a-card>
        <a-card class="margin-top" :loading="pageLoading">
          <div slot="title">Supplier Evaluation</div>
          <div slot="extra">
            <a-tag>{{data.header.kriteria}}</a-tag>
          </div>
          <div>
            <ul class="m-list-wrapper bordered">
              <li>
                <div class="m-display-flex space-between">
                  <span class="m-list-title" for>Price</span>
                  <span class="m-list-desc">{{data.header.price_point}} Point</span>
                </div>
                <span class="m-list-desc">{{data.header.price_desc}}</span>
              </li>
              <li>
                <div class="m-display-flex space-between">
                  <span class="m-list-title" for>Quality</span>
                  <span class="m-list-desc">{{data.header.quality_point}} Point</span>
                </div>
                <span class="m-list-desc">{{data.header.quality_desc}}</span>
              </li>
              <li>
                <div class="m-display-flex space-between">
                  <span class="m-list-title" for>Service</span>
                  <span class="m-list-desc">{{data.header.service_point}} Point</span>
                </div>
                <span class="m-list-desc">{{data.header.service_desc}}</span>
              </li>
              <li>
                <div class="m-display-flex space-between">
                  <span class="m-list-title" for>Risk Analysis</span>
                  <span class="m-list-desc">{{data.header.risk_analysis_point}} Point</span>
                </div>
                <span class="m-list-desc">{{data.header.risk_analysis_desc}}</span>
              </li>
            </ul>
          </div>
          <template slot="actions">
            <div class="m-text-align right">
              <h4 class="m-list-desc margin-remove">Total Ratings</h4>
              <h2 class="m-list-desc margin-remove">{{data.header.total_ratings}} Point</h2>
            </div>
          </template>
        </a-card>
        <a-collapse class="margin-top" activeKey>
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Status</h4>
              <div>
                <Status :status="data.last_status" />
              </div>
            </div>
            <a-timeline class="m-timeline">
              <a-timeline-item color="green">
                <div class="m-timeline-title">
                  Pembuat - {{ data.user_pembuat.tlc }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove">{{ data.user_pembuat.tanggal }}</h4>
                </div>
                <div class="m-timeline-footer">
                  <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                </div>
              </a-timeline-item>
              <a-timeline-item
                v-for="workflow in data.status"
                :key="workflow.step_no"
                :color="
                  workflow.status === 'On Process' ||
                  workflow.status === 'Delivered'
                    ? 'red'
                    : workflow.status === 'Waiting'
                    ? 'grey'
                    : 'green'
                "
              >
                <div class="m-timeline-title">
                  {{
                    workflow.actor === null ? workflow.jenis : workflow.actor
                  }}
                  {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                </div>
                <div class="m-timeline-body">
                  <h4
                    class="margin-remove"
                    v-if="workflow.tanggal_aksi !== null"
                  >
                    {{ workflow.tanggal_aksi }}
                  </h4>
                  <span
                    class="m-text-small"
                    v-if="workflow.remark == null || workflow.remark == ''"
                    >Tidak Ada Catatan</span
                  >
                  <span class="m-text-small" v-else>{{ workflow.remark }}</span>
                </div>
                <div class="m-timeline-footer">
                  <Status :status="workflow.status" />
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-collapse-panel>
        </a-collapse>
        <a-card
          class="margin-top"
          :loading="pageLoading"
          v-if="data.jenis.toLowerCase() === 'approve'"
        >
          <div slot="title">Manifest Actions</div>

          <a-form :form="form">
            <a-form-item label="Note">
              <a-textarea
                placeholder="Write the note here ... "
                :rows="2"
                v-decorator="['catatan']"
              />
            </a-form-item>
            <a-form-item label="Aksi">
              <a-select
                showSearch
                v-decorator="['aksi', { rules: [{ required: true }] }]"
              >
                <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                  item.aksi
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Password">
              <a-input
                type="password"
                placeholder="Password"
                v-decorator="['password', { rules: [{ required: true }] }]"
              />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-button
                @click="handleSubmit"
                block
                type="primary"
                html-type="submit"
                >Save</a-button
              >
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import Status from "@/components/Status.vue";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
export default {
  name: "manifestapproval",
  props: ["id"],
  components: { Status },
  mixins: [CurrencyFormat],
  data() {
    return {
      pageLoading: true,
      data: {},
      submit: {},
      pagination: {
        onChange: (page) => {
          //console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  computed: {
    ...mapGetters(["getScreen"]),
  },
  methods: {
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "public_manifest/manifest_evaluasi_suplier",
        params: {
          id: this.id,
        },
      })
        .then((response) => {
          //console.log(response);
          this.data = {
            header: response.data.suplier[0],
            actor: response.data.tlc,
            id: response.data.suplier[0].id_eval_supplier,
            jenis: response.data.jenis,
            last_status: response.data.last_status,
            user_pembuat: {
              tlc: response.data.suplier[0].user_pembuat,
              tanggal: response.data.suplier[0].tanggal_buat,
              status: "Created",
            },
            status: response.data.status_app,
            aksi: response.data.aksi,
          };
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
        });
    },
    handlePrint() {},
    handleAction() {},
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.pageLoading = false;
          this.displayMessage("choose-action");
          return;
        }

        let postData = new FormData();

        postData.append("id_manifest", this.data.id);
        postData.append("status", values.aksi);
        postData.append(
          "remark",
          values.catatan !== undefined ? values.catatan : ""
        );
        postData.append("tlc", this.data.actor);
        postData.append("password", values.password);

        axios({
          method: "post",
          url: this.$serviceUrl + "public_manifest/approval_evaluasi_suplier",
          processData: false,
          data: postData,
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            // console.log("error : " + err);
            if (err.response.data.status === false) {
              this.displayMessage("wrong-password");
            }
            this.pageLoading = false;
          });
      });
    },
  },
};
</script>

<style>
</style> 